import React from 'react';
import { IMAGE_BASE } from '../../constants/site';
import { TEAM_HIGHLIGHTS } from '../solutionsData';

const SolutionsTeam = () => (
  <div className="solutions-team">
    <div className="solutions-team__hero">
      <img src={`${IMAGE_BASE}/img36.jpg`} alt="Vientiane Traffic team" />
      <div className="solutions-team__hero-overlay" />
      <div className="solutions-team__hero-content">
        <h3>Dedicated professionals ensuring safety, excellence, and innovation.</h3>
        <p>Vientiane Traffic Team</p>
      </div>
    </div>
    <div className="solutions-team__grid">
      {TEAM_HIGHLIGHTS.map((item) => (
        <article key={item.title} className="solutions-team__card">
          <div className="solutions-team__card-media">
            <img src={item.image} alt={item.title} />
          </div>
          <h4>{item.title}</h4>
        </article>
      ))}
    </div>
  </div>
);

export default SolutionsTeam;
